import React from "react";
import { useFlash } from "../../context/flashcontext";
import PendingTimesheetsView from "./PendingTimesheetsView";

function PendingTimesheetsContainer(props) {
    return <PendingTimesheetsView {...props} />;
}

export default PendingTimesheetsContainer;
